export const CLOUDFRONT_URL = "https://d1vdfw8gkzbs2r.cloudfront.net"
export const DATA_VERSION = '1.3.0'; 
export const LATEST_TERMS_VERSION = "1.1"; 
